import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVoidIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"data-name": "Icon - Void",
		transform: "translate(-42 -1412)",
		children: [/* @__PURE__ */ _jsxs("g", {
			"data-name": "Ellipse 765",
			transform: "translate(42 1412)",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			children: [/* @__PURE__ */ _jsx("circle", {
				cx: 10,
				cy: 10,
				r: 10,
				stroke: "none"
			}), /* @__PURE__ */ _jsx("circle", {
				cx: 10,
				cy: 10,
				r: 9.25,
				fill: "none"
			})]
		}), /* @__PURE__ */ _jsx("g", {
			"data-name": "Interface-Essential / Navigate / navigation-down-circle",
			transform: "translate(52.985 1420.828) rotate(90)",
			children: /* @__PURE__ */ _jsx("g", {
				"data-name": "Group 742",
				transform: "translate(-3 -3)",
				children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
					"data-name": "Shape 3469",
					d: "M4.97,4.97-3-3",
					transform: "translate(3 3)",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5
				}) })
			})
		})]
	})
});
export { SvgVoidIcon as ReactComponent };
